export const IS_DISMISSED_FLAG = 'false';

export const isOnboardingStateEqual =
	(onboardingStateKey: string, onboardingStateValue: string) =>
	({ key, value }: { readonly key: string; readonly value: string | null | undefined }) =>
		key === onboardingStateKey && value === onboardingStateValue;
